export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Arrow-Left-Gray-63e6e1492057e96b40dda78823d43fe5.svg";